import { render, staticRenderFns } from "./PrivacyInfo.vue?vue&type=template&id=45493bde&scoped=true&"
import script from "./PrivacyInfo.vue?vue&type=script&lang=js&"
export * from "./PrivacyInfo.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyInfo.vue?vue&type=style&index=0&id=45493bde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45493bde",
  null
  
)

export default component.exports